export default __webpack_public_path__ + "static/media/arrow-white.2b2ba6cb.svg";